import { ServiceAgreementV2, ServiceRole } from 'pco-product-service-internal-consumer';
import { serviceRoleApi } from 'api';

export const callCreateServiceRole = async (
  serviceRole: Partial<ServiceRole>,
): Promise<ServiceAgreementV2 | undefined> => {
  if (serviceRole?.serviceAgreementUid) {
    return await serviceRoleApi.createServiceRole({
      serviceAgreementUid: serviceRole.serviceAgreementUid,
      serviceRole: serviceRole as ServiceRole,
    });
  }
};
